import { Component } from '@angular/core';
import {
  ActivatedRoute,
  Router,
  NavigationEnd,
  RouterModule,
} from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Breadcrumb } from 'src/app/shared/interfaces/breadcrumb';

const routeDataBreadcrumb = 'breadcrumb';
const routeParamBreadcrumb = 'routeParamBreadcrumb';
const routeAddBreadcrumbLink = 'addBreadcrumbLink';
const routeTitle = 'title';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  breadcrumbs: Breadcrumb[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.generateBreadcrumbs();
  }

  generateBreadcrumbs() {
    const onNavigationEnd = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    );

    onNavigationEnd.subscribe(() => {
      this.breadcrumbs = [];
      let currentRoute = this.activatedRoute.root;
      let currentUrl = '';

      while (currentRoute.children.length > 0) {
        const childrenRoutes = currentRoute.children;
        let breadcrumbLabel: any;
        let breadcrumbTitle: any;
        let url: any;

        childrenRoutes.forEach((route) => {
          currentRoute = route;
          breadcrumbLabel = false;

          if (route.outlet !== 'Primary School') return;

          const routeURL = route.snapshot.url
            .map((segment) => segment.path)
            .join('/');
          currentUrl += `/${routeURL}`;

          if (currentUrl === '/') {
            breadcrumbLabel = this.translateService.instant(
              'dashboard.capitalize'
            );
          }

          const hasData = route.routeConfig && route.routeConfig.data;

          // Dynamically pull breadcrumb labels from the route's data property
          if (hasData && route.snapshot.data[routeDataBreadcrumb]) {
            breadcrumbLabel = this.translateService.instant(
              route.snapshot.data[routeDataBreadcrumb]
            );
          }

          if (hasData && route.snapshot.data[routeTitle]) {
            breadcrumbTitle = route.snapshot.data[routeTitle];
          }

          // Check if the route has a custom link defined in the metadata
          if (route.snapshot.data.hasOwnProperty(routeAddBreadcrumbLink)) {
            url = route.snapshot.data[routeAddBreadcrumbLink];
          } else {
            url = currentUrl;
          }

          const breadcrumb: Breadcrumb = {
            label: breadcrumbLabel,
            url: url,
            title: breadcrumbTitle,
          };

          if (breadcrumbLabel) {
            this.breadcrumbs.push(breadcrumb);
          }
        });
      }
    });
  }
}
